import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContentfulState } from ".";


const initialState: ContentfulState = {
  contentful: null,
  loading: false,
  error: null,
};

export const contentfulSlice = createSlice({
  name: "contentful",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setContentful: (state, action: PayloadAction<any>) => {
      state.contentful = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
});

const contentfulReducer = contentfulSlice.reducer;

export const contentfulActions = contentfulSlice.actions;
export default contentfulReducer;
